import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { http } from "@/lib/api";

export const PlaceInput = ({ value, onChange, placeholder, testid }) => {
  const [q, setQ] = useState(value ? `${value.name}, ${value.country}` : "");
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open || q.trim().length < 2) { setList([]); return undefined; }
    const id = setTimeout(async () => {
      try {
        const r = await http.get("/places", { params: { q: q.trim() } });
        setList(Array.isArray(r.data) ? r.data : []);
      } catch { setList([]); }
    }, 250);
    return () => clearTimeout(id);
  }, [q, open]);
  const pick = (p) => { onChange(p); setQ(`${p.name}, ${p.country}`); setOpen(false); };
  return (
    <div className="relative">
      <input data-testid={testid} className="field" value={q} placeholder={placeholder} autoComplete="off"
        onChange={(e) => { setQ(e.target.value); setOpen(true); onChange(null); }} onBlur={() => setTimeout(() => setOpen(false), 180)} />
      {open && list.length > 0 && (
        <ul className="absolute z-30 mt-1 w-full rounded-2xl border border-[color:var(--line)] bg-white shadow-lg overflow-hidden">
          {list.map((p, i) => (
            <li key={`${p.name}-${p.lat}`}>
              <button type="button" data-testid={`${testid}-option-${i}`} onMouseDown={() => pick(p)}
                className="w-full text-left px-4 py-2.5 text-sm hover:bg-[color:var(--surface)] flex items-center gap-2">
                <MapPin className="w-3.5 h-3.5 text-[color:var(--saffron)]" />{p.name}<span className="text-[color:var(--muted)]">· {p.country}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="lbl">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-xs text-[color:var(--muted)]">{hint}</span>}
  </label>
);

export const BirthFields = ({ t, value, onChange, prefix, withName = true }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e?.target ? e.target.value : e });
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      {withName && <div className="sm:col-span-2"><Field label={t.common.name}><input data-testid={`${prefix}-name`} className="field" value={value.name} onChange={set("name")} /></Field></div>}
      <Field label={t.common.date}><input type="date" data-testid={`${prefix}-date`} className="field" value={value.date} onChange={set("date")} required /></Field>
      <Field label={t.common.time}><input type="time" data-testid={`${prefix}-time`} className="field" value={value.time} onChange={set("time")} required /></Field>
      <div className="sm:col-span-2"><Field label={t.common.place}><PlaceInput testid={`${prefix}-place`} value={value.place} onChange={set("place")} placeholder={t.common.placeHint} /></Field></div>
    </div>
  );
};

export const emptyBirth = { name: "", date: "", time: "", place: null };

export const toPayload = (b) => ({ date: b.date, time: b.time, lat: b.place.lat, lon: b.place.lon, tz: b.place.tz });
